import { Select, SelectRequiredSymbol } from '@riac/design-system';
import styled from 'styled-components';

export const PhoneBookType = styled.span`
  margin: 0 0.5rem;
  font-weight: 800;
`;

export const PhoneBookNumber = styled.span`
  margin: 0 0.5rem;
  line-height: 1.5;
`;

export const PhoneBookEntryContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
`;

export const PhoneBookEntry = styled.div`
  background-color: ${({ theme }) => theme.black[95]};
  border-bottom: 1px solid ${({ theme }) => theme.black[80]};
  margin: 0.75rem 0;
  padding: 0.5rem;
  display: flex;
  &>div {
    display: flex;
    &:first-child {
      flex: 1;
    }
  }
`;

export const PhoneBookSelect = styled(Select)`
  ${SelectRequiredSymbol} {
    color: white;
  }
`;
